/**
 * Shared POST body for PDP introduction block only.
 * bfBanner below keeps its original inline implementation unchanged.
 */
async function pdpIntroductionSubmitSubscription(email, settingsJson) {
  const fieldsArray = createFieldsArray(settingsJson);
  const contactListId = getContactListId(settingsJson);

  const subscribeInfoCookie = window.getCookieForEmarsys("subscribe_info");
  let eventTracking = null;

  if (subscribeInfoCookie) {
    try {
      const decodedCookie = decodeURIComponent(subscribeInfoCookie);
      eventTracking = JSON.parse(decodedCookie);
      delete eventTracking.ts;
    } catch (error) {
      console.warn("Failed to parse subscribe_info cookie:", error);
    }
  }

  const { apiUrl, acceptedLanguage, apiKey, xAppid } = theme.emailSubscription;
  const apiBody = {
    email,
    contactListId,
    fields: fieldsArray,
    ...(eventTracking && { eventTracking }),
  };

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apiKey: apiKey,
      traceId: traceId,
      "X-appid": xAppid,
      "Accepted-Language": acceptedLanguage,
    },
    body: JSON.stringify(apiBody),
  });

  return response.json();
}

document.addEventListener("alpine:init", () => {
  Alpine.data("bfBanner", () => ({
    loading: false,
    email: "",
    checked: false,
    isSuccess: false,
    errMsg: "",
    emailErrMsg: "",
    disclaimerErrMsg: "",

    async submitResult() {
      if (!this.checked) {
        this.disclaimerErrMsg = "Please tick agreement boxes to proceed.";
        return;
      }
      const isEmailValid = validateEmail(this.email);
      if (!isEmailValid) {
        this.emailErrMsg = "Email: invalid format!";
        return;
      }
      this.emailErrMsg = "";

      const fieldsArray = createFieldsArray(SettingJsons);
      const contactListId = getContactListId(SettingJsons);

      const subscribeInfoCookie = window.getCookieForEmarsys("subscribe_info");
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie);
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts;
          // console.log("eventTracking", eventTracking);
        } catch (error) {
          console.log("eventTracking error", subscribeInfoCookie);
          // console.warn("Failed to parse subscribe_info cookie:", error);
        }
      }

      const { apiUrl, acceptedLanguage, apiKey, xAppid } =
        theme.emailSubscription;

      const apiBody = {
        email: this.email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };
      this.loading = true;
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: traceId,
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });

        const data = await response.json();

        if (data.message === "Success") {
          this.isSuccess = true;
        }
      } catch (error) {
        this.errMsg =
          "Oops... Something went wrong, please refresh and try again.";
      } finally {
        this.loading = false;
      }
    },
  }));

  Alpine.data("pdpIntroductionSubscription", () => ({
    loading: false,
    email: "",
    checked: false,
    isSuccess: false,
    errMsg: "",
    emailErrMsg: "",
    disclaimerErrMsg: "",
    openSubscribe: false,
    installmentModalOpen: false,
    installmentDetailModalOpen: false,
    selectedInstallmentProvider: 1,
    showDiscountCode: true,
    hasCopied: false,
    copyButtonText: "Copy",
    copiedText: "Copied",
    successMessage: "Thank you for subscribing!",
    settingsJson: {},
    currentAmountCents: 0,
    installmentTitleTemplate: "12 payments of [price] at 0% interest with Alma.",
    installmentNum: 12,

    init() {
      const root = this.$el;
      const isExcluded = root.getAttribute("data-excluded-product") === "true";
      this.showDiscountCode = !isExcluded;
      this.copyButtonText = root.getAttribute("data-copy-text") || "Copy";
      this.copiedText = root.getAttribute("data-copied-text") || "Copied";
      this.successMessage =
        root.getAttribute("data-success-message") ||
        "Thank you for subscribing!";
      this.settingsJson = window.PDPIntroductionSettingJsons || {};
      this.installmentTitleTemplate =
        root.getAttribute("data-installment-title-template") ||
        this.installmentTitleTemplate;
      this.installmentNum = Number(
        root.getAttribute("data-installment-num") || this.installmentNum
      );
      this.currentAmountCents = Number(
        root.getAttribute("data-current-price-cents") || 0
      );
      this.syncInstallmentMainTitle();

      this._amountUpdateHandler = (event) => {
        const cents = Number(event?.detail?.amountCents);
        if (Number.isFinite(cents) && cents >= 0) {
          this.currentAmountCents = Math.round(cents);
          this.syncInstallmentMainTitle();
        }
      };
      window.addEventListener(
        "pdp:introduction-amount-update",
        this._amountUpdateHandler
      );

      if (!window.updatePdpIntroductionAmount) {
        window.updatePdpIntroductionAmount = (amountCents) => {
          const klarnaPlacement = document.querySelector(".pdp-installment-modal klarna-placement");
          if (klarnaPlacement) {
            klarnaPlacement.setAttribute("data-purchase-amount", amountCents);
            if (window.Klarna?.OnsiteMessaging?.refresh) {
              window.Klarna?.OnsiteMessaging?.refresh?.();
            }
          }
          if(document.querySelector(".pdp-installment-modal [data-pp-message]")){
            document.querySelector(".pdp-installment-modal [data-pp-message]").setAttribute('data-pp-amount', amountCents/100);
          }
          const installmentNum = Number(root.getAttribute("data-installment-num")) || 12;
          [1, 2, 3].forEach((providerIndex) => {
            const row = document.querySelector(
                `.pdp-installment-modal__row-text[data-installment-provider="${providerIndex}"]`
            );
            if (!row || !row.dataset.originalText) return;
            const monthlyCents = Math.round(amountCents / installmentNum);
            const normalized = Number.isFinite(monthlyCents) ? monthlyCents : 0;
            let formattedPrice;
            if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
              formattedPrice = theme.Currency
                  .formatMoney(normalized, theme.moneyFormat)
                  .replace(/([,.]00)(?!\d)/, "")
                  .replace(".", " ");
            } else {
              formattedPrice = (normalized / 100).toFixed(2).replace(/\.00$/, "").replace(".", " ");
            }
            row.innerHTML = row.dataset.originalText.replace('[price]', formattedPrice);
          });
          window.dispatchEvent(new CustomEvent('pdp:installment-links-rebind'));
          window.dispatchEvent(
            new CustomEvent("pdp:introduction-amount-update", {
              detail: { amountCents },
            })
          );
        };
      }

      this._rebindInstallmentLinksHandler = () => {
        this.bindInstallmentDetailLinks();
      };
      window.addEventListener('pdp:installment-links-rebind', this._rebindInstallmentLinksHandler);

      this.$nextTick(() => {
        this.bindInstallmentDetailLinks();
      });
    },

    bindInstallmentDetailLinks() {
      [1, 2, 3].forEach((providerIndex) => {
        const row = this.$el.querySelector(
          `.pdp-installment-modal__row-text[data-installment-provider="${providerIndex}"]`
        );
        if (!row) return;

        row.querySelectorAll("a").forEach((trigger) => {
          if (trigger.dataset.installmentPopupBound === "1") return;
          trigger.dataset.installmentPopupBound = "1";
          trigger.addEventListener("click", (event) => {
            event.preventDefault();
            this.openInstallmentDetail(providerIndex);
          });
        });
      });
    },

    formatInstallmentMoney(cents) {
      const normalized = Number.isFinite(Number(cents)) ? Number(cents) : 0;
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
        return theme.Currency
          .formatMoney(normalized, theme.moneyFormat)
          .replace(/([,.]00)(?!\d)/, "");
      }
      return (normalized / 100).toFixed(2).replace(/\.00$/, "");
    },

    calculateInstallmentTotal(termValue, interestValue) {
      const base = Number(this.currentAmountCents || 0);
      const interest = Number(interestValue || 0);
      if (!Number.isFinite(base) || base < 0) return 0;
      if (!Number.isFinite(interest) || interest <= 0) return Math.round(base);
      return Math.round(base + (base * interest) / 100);
    },

    calculateInstallmentMonthly(termValue, interestValue) {
      const term = Number(termValue || 0);
      if (!Number.isFinite(term) || term <= 0) return 0;
      const total = this.calculateInstallmentTotal(termValue, interestValue);
      return Math.round(total / term);
    },

    getInstallmentMainTitle() {
      const monthly = this.calculateInstallmentMonthly(this.installmentNum, 0);
      const monthlyText = this.formatInstallmentMoney(monthly);
      return this.installmentTitleTemplate.replace("[price]", monthlyText);
    },

    syncInstallmentMainTitle() {
      const el = this.$el?.querySelector?.("[data-installment-main-title]");
      if (!el) return;
      el.textContent = this.getInstallmentMainTitle();
    },

    openInstallmentDetail(providerIndex) {
      this.selectedInstallmentProvider = providerIndex;
      this.installmentDetailModalOpen = true;
    },

    async submitResult() {
      this.errMsg = "";
      this.emailErrMsg = "";
      this.disclaimerErrMsg = "";

      if (
        !this.settingsJson ||
        !String(this.settingsJson.contact_list_id || "").trim()
      ) {
        this.errMsg = "Subscription is unavailable for this product.";
        return;
      }
      if (!this.checked) {
        this.disclaimerErrMsg = "Please tick agreement boxes to proceed.";
        return;
      }
      const isEmailValid = validateEmail(this.email);
      if (!isEmailValid) {
        this.emailErrMsg = "Email: invalid format!";
        return;
      }

      this.loading = true;

      try {
        const data = await pdpIntroductionSubmitSubscription(
          this.email,
          this.settingsJson
        );
        if (data.message === "Success") {
          this.isSuccess = true;
        } else {
          this.errMsg =
            "Oops... Something went wrong, please refresh and try again.";
        }
      } catch (error) {
        this.errMsg =
          "Oops... Something went wrong, please refresh and try again.";
      } finally {
        this.loading = false;
      }
    },

    async copyCode() {
      const input = this.$refs.discountCodeInput;
      if (!input) return;

      const code = input.value || "";
      if (!code) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          input.focus();
          input.select();
          document.execCommand("copy");
        }
        this.copyButtonText = this.copiedText;
        this.hasCopied = true;
      } catch (error) {
        input.focus();
        input.select();
      }
    },
  }));
});
